export const sidebarData = [
  {
    userId: "bg",
    subMenu: null,
    name: "EMD Details",

    svg: `<svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5 1.5H14L20 7V22C20 24 18.5 25.5 16.5 25.5H5.5C3.5 25.5 2 24 2 22V5C2 3 3.5 1.5 5 1.5Z" stroke="black" stroke-width="1.2"/>
  <path d="M14 1.5V7H20" stroke="black" stroke-width="1.2"/>
  <path d="M11 11C9.5 11 8.5 12 8.5 13.5C8.5 15.5 11 17 11 17C11 17 13.5 15.5 13.5 13.5C13.5 12 12.5 11 11 11Z" stroke="black" stroke-width="1.2"/>
  </svg>`,

    svgfill: `<svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5 1.5H14L20 7V22C20 24 18.5 25.5 16.5 25.5H5.5C3.5 25.5 2 24 2 22V5C2 3 3.5 1.5 5 1.5Z" stroke="#2576bc" stroke-width="1.2"/>
  <path d="M14 1.5V7H20" stroke="#2576bc" stroke-width="1.2"/>
  <path d="M11 11C9.5 11 8.5 12 8.5 13.5C8.5 15.5 11 17 11 17C11 17 13.5 15.5 13.5 13.5C13.5 12 12.5 11 11 11Z" stroke="#2576bc" stroke-width="1.2"/>
  </svg>`,
  },
];
